export default class UserAgent {
  constructor() {
    this.html = document.documentElement;
    this.ua = navigator.userAgent;
    this.init();
  }
  init() {
    if (/Windows/i.test(this.ua)) this.html.classList.add("windows");
    else if (/Macintosh/i.test(this.ua)) this.html.classList.add("mac");
    else if (/Linux/i.test(this.ua)) this.html.classList.add("linux");

    if (/Chrome\/\d+/i.test(this.ua)) this.html.classList.add("chrome");
    else if (/Safari\/\d+/i.test(this.ua) && !/Chrome/i.test(this.ua))
      this.html.classList.add("safari");
    else if (/Firefox\/\d+/i.test(this.ua)) this.html.classList.add("firefox");
    else if (/Edge\/\d+/i.test(this.ua)) this.html.classList.add("edge");

    if (/Mobile/i.test(this.ua)) this.html.classList.add("mobile");
    else this.html.classList.add("desktop");
  }
}
